/**
 * @name 千分位
 * @author hq
 * @param str 
 * @returns str: 1,234,567
 */
export function thousandth_formatter(str: number | string) {
  if (str) {
    let newstr = str?.toString();
    var re = /(?=(?!(\b))(\d{3})+(\b))/g;
    newstr = newstr.replace(re, ",");
    return newstr;
  } else {
    return str;
  }
}

/**
 * @name    拼接shadercolor,用于显示heatmap的配色
 * @author hq
 * @param  arr：string['#112233' | '112233']，flag：是否反转
 * @returns vec[](vec3(0.000 ))
 */
export function formatterRGBToVec3(arr: string[], flag: boolean) {
  var result = [];
  var result_ = '';
  for(let i = 0; i < arr.length; i++){
    var sub = [];
    var item = arr[i].includes('#') ? arr[i].substring(1) : arr[i];
    var r = (parseInt(item.substring(0,2),16) / 255).toFixed(6);
    var g = (parseInt(item.substring(2,4),16) / 255).toFixed(6);
    var b = (parseInt(item.substring(4,6),16) / 255).toFixed(6);
    sub[0] = r;
    sub[1] = g;
    sub[2] = b;
    result.push(sub);
  };
  result = flag ? result.reverse() : result;
  result.forEach((item,index:number)=>{
    if(index === result.length-1){
      result_=result_+'vec3 ('+item.toString()+ ')';
    }else{
      result_=result_+'vec3 ('+item.toString()+ '),';
    }
  });
  return `vec3[${arr.length}](${result_})`;
}

/**
 * @name  16进制转rgb
 * @param str 
 * @returns rgb number[]
 */
export function set16ToRgb(str: string){
  var reg = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/
  if(!reg.test(str)){return [255,255,255]}
  let newStr = (str.toLowerCase()).replace(/\#/g,'')
  let len = newStr.length;
  if(len == 3){
      let t = ''
      for(var i=0;i<len;i++){
          t += newStr.slice(i,i+1).concat(newStr.slice(i,i+1))
      }
      newStr = t
  }
  let arr = []; //将字符串分隔，两个两个的分隔
  for(var i =0;i<6;i=i+2){
      let s = newStr.slice(i,i+2)
      arr.push(parseInt("0x" + s))
  }
  return arr;
}

/**
 * @name    rgbToHex
 * @param r 
 * @param g 
 * @param b 
 * @param flag 是否添加#
 * @returns 'ffffff' | '#ffffff'
 */
export function rgbToHex (r: number, g: number, b: number, flag?:boolean) {
  const toHex = (num: number) => {
    const _num = num > 255 ? 255 : num < 0 ? 0 : num;
    const hex = _num.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
  };
  return flag ? `${toHex(r)}${toHex(g)}${toHex(b)}` : `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

/**
 * @name 主要用于生成image图像的shader
 * @param info: layerinfo中携带的参数对象
 * @returns imageLayer shader info对象
 */
interface urlOption {
  sn: string,
  source: string,
  IF_color?: string,
  name?: string,
  num_channels?: number;
  gray_level_elbow?: number,
  max_gray_level?: number,
  file?: string
}
export interface image_layer_info_interface extends urlOption {
  genecolor?: string,
  image_shader?: string
}
export function getNewRpiImageType(info:any){
  const color = typeof info.IF_color === 'string' ? info.IF_color : rgbToHex(info.IF_color[0], info.IF_color[1], info.IF_color[2], true).replace('#','');
  info['genecolor'] = info.num_channels > 1 ? 'E26EF2' : color ;
  info['image_shader'] = info.num_channels > 1 ? `#uicontrol vec3 color color(default="#E26EF2")
    #uicontrol float brightness slider(min=-1, max=1)
    #uicontrol float contrast slider(min=-3, max=3, step=0.01)
    void main() {
      emitRGB(
        vec3( (toNormalized(getDataValue(0)) + brightness ) * exp(contrast),
              (toNormalized(getDataValue(1)) + brightness ) * exp(contrast),
              (toNormalized(getDataValue(2)) + brightness ) * exp(contrast)));
    }` : "#uicontrol invlerp normalized\n#uicontrol float brightness slider(min=-1, max=1)\n#uicontrol float contrast slider(min=-3, max=10, step=0.01, default=1.0)\nvoid main() {\n emitRGB(color*(normalized()+brightness)*exp(contrast));\n#uicontrol vec3 color color(default=\"#" + info.genecolor + "\")\n}";
    return info
}

export function getData(){
  let n=new Date()
  return n.toLocaleDateString().replace(/\//g, "") + (n.toTimeString().substr(0, 8)).replace(/\:/g,'');
}